"use client";

import Image from "next/image";
import classes from "./SearchPopup.module.scss";
import SearchInput from "./SearchInput/SearchInput";
import { useEffect, useState } from "react";
import { getArticleByCategory } from "@/actions/fetchQueryData";
import { fetchArticleByData } from "@/actions/admin/index";
import { useRouter } from "next/navigation";

interface SearchPopupProps {
  setSearchVisbility: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchPopup: React.FC<SearchPopupProps> = ({ setSearchVisbility }) => {
  const router = useRouter();
  const [selectedTag, setSelectedTag] = useState<string>("");
  const [articles, setArticles] = useState<any[]>([]);

  const readMoreClick = (slug: any) => {
    router.push(`/article/${slug}`);
    setSearchVisbility(false);
  };

  const [selectedTitle, setSelectedTitle] = useState<string>("");

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = selectedTag
          ? await getArticleByCategory(selectedTag)
          : selectedTitle
          ? await fetchArticleByData({ title: selectedTitle, limit: 10, page: 1 })
          : { articles: [] };

        setArticles(data?.articles || []);
      } catch (error) {
        console.error("Error fetching articles::", error);
      }
    };

    fetchArticles();
  }, [selectedTag, selectedTitle]);


  return (
    <div className={classes["search-popup-container"]}>
      <SearchInput selectedTag={selectedTag} setSelectedTag={setSelectedTag} setSelectedTitle={setSelectedTitle} setSearchVisbility={setSearchVisbility}/>

      {articles.length > 0 && (
        <div className={classes["latest-news-block-container"]}>
          <p className={classes["latest-text"]}>Latest</p>
          <div className={`${classes["latest-container"]}`}>
            {articles.slice(0, 4).map((article: any, index) => (
              <div
                key={index}
                className={classes["latest-block-ele"]}
                onClick={() => {
                  setSelectedTitle(article.title);
                  readMoreClick(article.slug);
                }}
              >
                <div className={classes["image-container"]}>
                  <Image
                    src={`${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/${article.imageUrl}`}
                    alt={article.title}
                    fill
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </div>

                <p className={classes["news-text"]}>{article.title}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchPopup;
